import { render, staticRenderFns } from "./MyStatistics.vue?vue&type=template&id=6a590ed2&"
import script from "./MyStatistics.vue?vue&type=script&lang=js&"
export * from "./MyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MyStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports